var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandAndPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 432,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.94 192.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#e4aa82;}.cls-3{fill:#ecb087;}.cls-4{fill:#fac7a5;}.cls-5{fill:#fbc398;}.cls-15,.cls-6,.cls-8{fill:#efb288;}.cls-7{fill:#f6ba90;}.cls-8{opacity:0.25;mix-blend-mode:multiply;}.cls-9{fill:#0d72b9;}.cls-10{fill:#e5d3ae;}.cls-11{fill:#3d2031;}.cls-12{fill:#d1bb93;}.cls-13{fill:#f7e6ba;}.cls-14{fill:#603916;}.cls-15{opacity:0.43;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.34,89.73S78.61,64,75.37,64s-18-4.24-21.74,1.06-7.4,16.43-7.4,16.43l24.05,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.17,73.2c-2.15-.54-10.92-3.46-12-3.1s-9.2,4-9.8,6.6-5.87,16.64-6.24,18.71c-1.4,7.85,9.3,9.21,11.17,4.28C52,98,56.28,87.93,57.79,85.91s4.64-1.36,8.13.35A99.33,99.33,0,0,0,76.77,90.2s3.51-13.14,2.88-14S68.17,73.2,68.17,73.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.17,67.87s15.61-1.73,17.69,0,2.43,10.41,5.21,13.53,2.08,9.37,2.08,9.37l25.68-9.71L91.68,54,67.05,48.44,53.17,52.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.48,52.72c-1.09.61-8.91,4.39-14.11,7.86S33,65,33,66.14c.72,8.71,9.63,11.67,15.61,6.59,5-4.22,14.58-7.63,14.23-13.19s4.86-9.37,4.86-9.37S66.58,46.47,55.48,52.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52,43.23c.78.52,9.28,4.43,10.15,4.08a9.76,9.76,0,0,0,2.14-2.79,28.16,28.16,0,0,1-9.45-3.6c-1.1-.67-2.64-1-2.84-.46C51.83,41.35,51.49,42.92,52,43.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.11,88c-.69-2.55-13.19-41.88-16.19-41.64-7.65-3.13-21.12.49-32.91-1.85-.76,1.24-1.19,2.5-1.65,2.68-.87.35-9.37-3.55-10.15-4.07-.46-.31-.4-1.48-.28-2.37-1.8,3.93-3.77,9.09,2.54,12.69,6.47,3.7,11.11,2.6,12.27,2.37S79,60.53,85.82,59.61c.61,5.18.89,12.87,4.39,20.09,1.39,2.88-12.39,6.21-15.6,8.61A58.28,58.28,0,0,1,69,77.52L49.72,80.39s3.47,18.51.24,26.84c-2.25,5.77,1.43,32.85,3.21,43.57,0,.24,6,10.24,6.24,12.15,1.28,8.79.76,28.67,2.08,28.8C69,192.5,98,192,98,192s-3.59-23.42-3-21.89c-.28-4.42-1.18-16.42,1.43-23.54C107.33,116.94,113.8,90.57,113.11,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.86,43.32a41.64,41.64,0,0,0,6.74,3,14.84,14.84,0,0,0,3.51.85,1.35,1.35,0,0,0,.38,0c.06,0,.06,0,.11-.07l.14-.17c.17-.24.33-.49.49-.76.3-.53.58-1.08.86-1.63a12.21,12.21,0,0,1-.61,1.76,7.49,7.49,0,0,1-.44.84l-.13.2a.61.61,0,0,1-.26.21,1.31,1.31,0,0,1-.53.1,12.23,12.23,0,0,1-3.68-.81A26.54,26.54,0,0,1,55,45.29,18.76,18.76,0,0,1,51.86,43.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.45,87.77l.25-.18c1.45-1,8.61-6,10.27-6.53l1.85-.58,3.24-.23s3,1.39,2.43,1.85S76.3,89.73,74.45,87.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83,59.37a23.62,23.62,0,0,0,2.81.24s-.21,2.36.31,2.71,1.22-6.25,2.08-6.94a23.62,23.62,0,0,0,2.61-3.12s-4.69,5-5.21,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M67.39,54.51l.18-3.12S66.35,55.55,66,55.73l.35-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.91,118c-.17.52-6.77,21.69-8.5,25.51a38.39,38.39,0,0,0-2.78,11.62c-.17,2.6,3.3,35.92,3.3,35.92H93.42S87.52,155,95.15,142C97.25,138.39,105.91,118,105.91,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.33,80.36s2.26-2.43,3.64-2.6,5.21-1,5.21-1,1.62.46,2,1.44a31.51,31.51,0,0,1,.93,4.11s-6.77,1.91-8.33,1.56S57.33,80.36,57.33,80.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.71,49c-.69.52-3.47.35-3.64,3.64S97.06,80.36,99,83s9.2,6.42,10.24,5.2-5-21.51-6.6-25.85S96.71,49,96.71,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M79.66,83.9c1.76.36,19.75,25,22.21,29.27s4,4.84,4,4.84l3.37-10.13S93.76,88.13,90.59,86,79.66,83.9,79.66,83.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 64.21,
    y: -9.95,
    width: 9.25,
    height: 151.29,
    transform: "translate(-26.21 70.18) rotate(-46.37)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "17.27 10.15 10.89 16.84 4.19 4.42 4.73 3.86 17.27 10.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M120.39,121.24l13.73,13.09a4.63,4.63,0,0,0,6.54-.16h0a4.64,4.64,0,0,0-.15-6.54l-13.73-13.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6.07,5.85c.31.05,9.42,8.26,10.22,8.39,3.1.52,3.07-1.84,3-2.27s-2-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M12.18,16.92s1.43,2.14,3.59-.25a2.06,2.06,0,0,0-.31-3.07L5.13,4.83l6.81,11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M12.94,18.76s.13-.27-.76-1.84S4.88,5.08,4.88,5.08L11,16.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M5.37,5.19c.31.06,9.42,8.27,10.21,8.41,3.08.54,3-1.79,3-2.22S17.27,10,17.27,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M11.53,16.21S13,18.34,15.09,16a2.05,2.05,0,0,0-.34-3L4.43,4.17l6.86,11.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M12.31,18s.12-.26-.78-1.83S4.19,4.42,4.19,4.42l6.7,12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M14.75,13,4.43,4.17l10.82,8.77,1.16.92s-1.15-.62-.63.66C16.22,15.58,14.75,13,14.75,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M11.81,16.61,4.34,4.45S11.83,16,12.08,16.2a10.79,10.79,0,0,1,.82,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M5.79,6c.07.19,6,10,6.87,10.15s2.63-.43,2.42-1.47S5.79,6,5.79,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6.05,5.18C6.23,5.24,15.53,13,16.27,13s2.89-1.14,1.39-2.21S6.05,5.18,6.05,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M10.74,16.6c0-.15-4.82-9.15-4.82-9.15s5.91,9.71,5.54,9.66A1.48,1.48,0,0,1,10.74,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M0,0C-.31.18,4.9,5.78,4.9,5.78L6.14,4.56S.34-.17,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.78,68c3.18-.41,6.69-.74,9.74-2.43-2.32-5-6.46-14.69-6.46-14.69S48.5,49.15,44.65,55C46,59.53,48.75,68.44,51.78,68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.9,77.64a106.92,106.92,0,0,1-6.38-9.9c-.26-.52-.61-1.27-1-2.13-3.05,1.69-6.56,2-9.74,2.43S46,59.53,44.65,55a14.74,14.74,0,0,0-2,4.69c-1.79,7.35,4.37,22.93,11.64,25C70.75,89.44,68.9,77.64,68.9,77.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M44.78,55.17a29,29,0,0,0,.78,3,28.11,28.11,0,0,0,1,3,12.83,12.83,0,0,0,3.3,5.16,4.22,4.22,0,0,0,2.74,1.05,21.68,21.68,0,0,0,3.11-.22,16,16,0,0,0,3-.72,11.82,11.82,0,0,0,2.84-1.32,13.51,13.51,0,0,1-5.82,2.42,18.79,18.79,0,0,1-3.17.3,4.71,4.71,0,0,1-3-1.13,12.66,12.66,0,0,1-3.35-5.41A28.34,28.34,0,0,1,44.78,55.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M46.41,76.7c0-.07.13.11.23.21,1,1,4,4.46,5.4,4.93a15.47,15.47,0,0,1,2.34,1s-.26,19.87-.17,20.48-2.43,13.27-2.52,14.83-.09,17.7-.09,17.7-3.11-24.9-1.9-28C51.17,104,51.78,94.76,51,89c-.3-2.17-1-7.12-1-7.12S46.52,77.17,46.41,76.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandAndPencil);
export default __webpack_public_path__ + "static/media/hand-and-pencil.3b5b0e8c32de643ae3d440b67e138e55.svg";
export { ForwardRef as ReactComponent };